var $0e900134b7612f62$exports = {};
$0e900134b7612f62$exports = import.meta.resolve("5wrvI");


var $6afe01b2225bf857$exports = {};
$6afe01b2225bf857$exports = import.meta.resolve("11bMw");


var $7a3fe5bfe879c487$exports = {};
$7a3fe5bfe879c487$exports = import.meta.resolve("gjcpS");


var $ca0d72a72b133ae1$exports = {};
$ca0d72a72b133ae1$exports = import.meta.resolve("2IRIO");


var $59745d64825f793c$exports = {};
$59745d64825f793c$exports = import.meta.resolve("gLDpG");


var $ffcebe2d2076f726$exports = {};
$ffcebe2d2076f726$exports = import.meta.resolve("cV9CI");


var $1d93fd0dbcb973ed$exports = {};
$1d93fd0dbcb973ed$exports = import.meta.resolve("e0PSj");


var $7a4818e25df7c6be$exports = {};
$7a4818e25df7c6be$exports = import.meta.resolve("brU7t");


var $cb2f6c2a98cab990$exports = {};
$cb2f6c2a98cab990$exports = import.meta.resolve("6feCj");


var $47315d3224991732$exports = {};
$47315d3224991732$exports = import.meta.resolve("4d1w6");


var $b3b2bf720747039a$exports = {};
$b3b2bf720747039a$exports = import.meta.resolve("6z470");


var $31bfec08a9fb9b54$exports = {};
$31bfec08a9fb9b54$exports = import.meta.resolve("12sY4");


var $5036cd95901b0120$exports = {};
$5036cd95901b0120$exports = import.meta.resolve("2idvw");


var $78a5e5f995fd32e3$exports = {};
$78a5e5f995fd32e3$exports = import.meta.resolve("gSJjA");


var $e818286aa3e2cc66$exports = {};
$e818286aa3e2cc66$exports = import.meta.resolve("hfmQO");


var $6ab9c9ab325a4d05$exports = {};
$6ab9c9ab325a4d05$exports = import.meta.resolve("ddqzT");


const $b62735b823c2fe03$var$drawings = [
    new URL($0e900134b7612f62$exports),
    new URL($6afe01b2225bf857$exports),
    new URL($7a3fe5bfe879c487$exports),
    new URL($ca0d72a72b133ae1$exports),
    new URL($59745d64825f793c$exports),
    new URL($ffcebe2d2076f726$exports),
    new URL($1d93fd0dbcb973ed$exports),
    new URL($7a4818e25df7c6be$exports),
    new URL($cb2f6c2a98cab990$exports),
    new URL($47315d3224991732$exports),
    new URL($b3b2bf720747039a$exports),
    new URL($31bfec08a9fb9b54$exports),
    new URL($5036cd95901b0120$exports),
    new URL($78a5e5f995fd32e3$exports),
    new URL($e818286aa3e2cc66$exports),
    new URL($6ab9c9ab325a4d05$exports)
];
const $b62735b823c2fe03$var$button = document.getElementById('cat-drawing');
const $b62735b823c2fe03$var$reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const $b62735b823c2fe03$var$historyKey = 'portfolio-cat-history';
const $b62735b823c2fe03$var$historyLimit = Math.min(10, $b62735b823c2fe03$var$drawings.length - 1);
let $b62735b823c2fe03$var$recent = [];
let $b62735b823c2fe03$var$version = 0;
let $b62735b823c2fe03$var$animations = [];
function $b62735b823c2fe03$var$readHistory() {
    try {
        const saved = JSON.parse(window.localStorage.getItem($b62735b823c2fe03$var$historyKey) || '[]');
        if (Array.isArray(saved)) $b62735b823c2fe03$var$recent = saved.filter((index, position)=>Number.isInteger(index) && index >= 0 && index < $b62735b823c2fe03$var$drawings.length && saved.lastIndexOf(index) === position).slice(-$b62735b823c2fe03$var$historyLimit);
    } catch  {
    // Keep an in-memory history when browser storage is unavailable or invalid.
    }
    return $b62735b823c2fe03$var$recent;
}
function $b62735b823c2fe03$var$rememberCat(index) {
    $b62735b823c2fe03$var$recent = [
        ...$b62735b823c2fe03$var$readHistory().filter((previous)=>previous !== index),
        index
    ].slice(-$b62735b823c2fe03$var$historyLimit);
    try {
        window.localStorage.setItem($b62735b823c2fe03$var$historyKey, JSON.stringify($b62735b823c2fe03$var$recent));
    } catch  {
    // Drawing still works when the browser blocks persistent storage.
    }
}
function $b62735b823c2fe03$var$stopDrawing() {
    $b62735b823c2fe03$var$animations.forEach((animation)=>animation.cancel());
    $b62735b823c2fe03$var$animations = [];
    $b62735b823c2fe03$var$button.querySelectorAll('path').forEach((path)=>{
        path.style.removeProperty('stroke-dasharray');
        path.style.removeProperty('stroke-dashoffset');
    });
}
function $b62735b823c2fe03$var$finishDrawing() {
    $b62735b823c2fe03$var$stopDrawing();
    $b62735b823c2fe03$var$button.dataset.state = 'ready';
}
function $b62735b823c2fe03$var$draw(svg) {
    if ($b62735b823c2fe03$var$reducedMotion.matches || !Element.prototype.animate) {
        $b62735b823c2fe03$var$finishDrawing();
        return;
    }
    const ticket = $b62735b823c2fe03$var$version;
    const strokes = [
        ...svg.querySelectorAll('path')
    ].map((path)=>({
            path: path,
            length: Math.max(path.getTotalLength(), 1)
        }));
    const totalWeight = strokes.reduce((sum, stroke)=>sum + stroke.length + 20, 0);
    let delay = 0;
    $b62735b823c2fe03$var$button.dataset.state = 'drawing';
    $b62735b823c2fe03$var$animations = strokes.map(({ path: path, length: length })=>{
        const duration = 2600 * (length + 20) / totalWeight;
        path.style.strokeDasharray = `${length} ${length}`;
        path.style.strokeDashoffset = String(length);
        const animation = path.animate([
            {
                strokeDashoffset: String(length)
            },
            {
                strokeDashoffset: '0'
            }
        ], {
            duration: duration,
            delay: delay,
            easing: 'linear',
            fill: 'forwards'
        });
        delay += duration;
        return animation;
    });
    Promise.all($b62735b823c2fe03$var$animations.map((animation)=>animation.finished)).then(()=>{
        if (ticket === $b62735b823c2fe03$var$version) $b62735b823c2fe03$var$finishDrawing();
    }).catch(()=>{}); // A new cat or reduced-motion change cancels the old drawing.
}
async function $b62735b823c2fe03$var$chooseCat() {
    const ticket = ++$b62735b823c2fe03$var$version;
    $b62735b823c2fe03$var$button.dataset.state = 'loading';
    $b62735b823c2fe03$var$stopDrawing();
    const history = $b62735b823c2fe03$var$readHistory();
    const available = $b62735b823c2fe03$var$drawings.map((_, index)=>index).filter((index)=>!history.includes(index));
    const selected = available[Math.floor(Math.random() * available.length)];
    try {
        const response = await fetch($b62735b823c2fe03$var$drawings[selected]);
        if (!response.ok) throw new Error('Cat drawing unavailable');
        const document1 = new DOMParser().parseFromString(await response.text(), 'image/svg+xml');
        if (ticket !== $b62735b823c2fe03$var$version) return;
        const svg = document1.documentElement;
        if (svg.localName !== 'svg') throw new Error('Invalid cat drawing');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        svg.removeAttribute('aria-labelledby');
        svg.removeAttribute('role');
        $b62735b823c2fe03$var$button.replaceChildren(svg);
        $b62735b823c2fe03$var$rememberCat(selected);
        $b62735b823c2fe03$var$draw(svg);
    } catch  {
        // Keep the complete inline cat visible if loading the selected asset fails.
        if (ticket === $b62735b823c2fe03$var$version) $b62735b823c2fe03$var$finishDrawing();
    }
}
if ($b62735b823c2fe03$var$button) {
    $b62735b823c2fe03$var$button.addEventListener('click', $b62735b823c2fe03$var$chooseCat);
    $b62735b823c2fe03$var$reducedMotion.addEventListener('change', ()=>{
        if ($b62735b823c2fe03$var$reducedMotion.matches && $b62735b823c2fe03$var$button.dataset.state === 'drawing') $b62735b823c2fe03$var$finishDrawing();
    });
    window.addEventListener('pageshow', (event)=>{
        if (event.persisted && $b62735b823c2fe03$var$button.dataset.state === 'drawing') $b62735b823c2fe03$var$finishDrawing();
    });
    $b62735b823c2fe03$var$chooseCat();
}


//# sourceMappingURL=repo.dbdf9abb.js.map
